import { useRef } from 'react';

const areArraysEqual = <T>(a: readonly T[], b: readonly T[]): boolean =>
  a.length === b.length && a.every((item, index) => Object.is(item, b[index]));

export function useStableArray<T>(next: T[]): T[];
export function useStableArray<T>(next: T[] | undefined): T[] | undefined;
export function useStableArray<T>(next: T[] | undefined): T[] | undefined {
  const ref = useRef(next);
  if (
    ref.current !== next &&
    (ref.current === undefined ||
      next === undefined ||
      !areArraysEqual(ref.current, next))
  ) {
    ref.current = next;
  }
  return ref.current;
}
